import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {getExtensionTagTitle} from 'yougile-model'
import {FilterId} from '@components/extensions-gallery/extensions-gallery'
import {ExtensionStore} from '../../extensions-store'

const TwTags = tw.div`
  flex
  flex-wrap
  gap-6
`

type TwTag = {
  $isActive?: boolean
}

const TwTag = tw.div<TwTag>`
  px-6
  py-2
  text-xxs-regular
  rounded-4

  cursor-default

  ${p =>
    p.$isActive ? 'bg-grey text-invert' : 'bg-background-active text-secondary'}
`

type ExtensionTagsProps = {
  extension: ExtensionStore
  onClickTag?: (tag: FilterId) => void
}

export const ExtensionTags = (props: ExtensionTagsProps) => {
  const {extension, onClickTag} = props

  return (
    <TwTags>
      {extension.enabled ? (
        <TwTag $isActive onClick={() => onClickTag?.('enabled')}>
          {Lang.msg.extensions.gallery.filters.enabled}
        </TwTag>
      ) : null}

      {extension.tags.map((tag, index) => (
        <TwTag key={`${tag}-${index}`} onClick={() => onClickTag?.(tag)}>
          {getExtensionTagTitle(tag)}
        </TwTag>
      ))}
    </TwTags>
  )
}
